<template>
  <el-container class="indexCon" :class="{'mourningMode':this.$openobituary==1}">
    <title>首页</title>
    <!-- <Header></Header> -->

    <el-main ref="mainContain">
      <section class="userCon">
        <div class="userWrap">
          <h3>{{userInfoMd.username?userInfoMd.username:'--'}}，
            <span v-if="dateTime(valdate) == dateTime(new Date())"><i class="redColor">温馨提示：</i>您好！系统服务<i class="redColor">今天过期</i></span>
            <span v-else-if="getDuration(valdate,1)-getDuration(new Date().getTime())>0&&getDuration(valdate,1)-getDuration(new Date().getTime())<8"><i class="redColor">温馨提示：</i>您好！系统服务将于<i class="redColor fwBold">{{getDuration(valdate,1)-getDuration(new Date().getTime())}}</i>天后过期</span>
          </h3>
          <span>今天是{{nowDateTime}} {{nowDateDay}}，欢迎回到
            <template v-if="!isRuralVitalization">门店管理中心 
              <template v-if="ElementControls('system_version')==0"> - 简易版</template>
              <template v-else-if="ElementControls('system_version')==1"> - 标准版</template>
              <template v-else-if="ElementControls('system_version')==2"> - 营销版</template>
              <template v-else-if="ElementControls('system_version')==3"> - OMS版</template>
              <template v-else-if="ElementControls('system_version')==4"> - 企业集成定制版</template>
              <template v-else-if="ElementControls('system_version')==5"> - 协会/集中市场专版</template>
              <template v-else-if="ElementControls('system_version')==6"> - 溯源版</template>
              <template v-else-if="ElementControls('system_version')==7"> - 农文旅供应链版</template>
              <template v-else-if="ElementControls('system_version')==8"> - 私有化部署版</template>
              <template v-else-if="ElementControls('system_version')==9"> - 入门版</template>
              <template v-else-if="ElementControls('system_version')==10"> - 农文旅企业版</template>
            </template>
            <template v-else>门店管理中心</template>
          。</span>
        </div>
        <!-- <div class="noticeCon">
          <a href="javascript:;" @click="getModuleShow">
            <b><i class="iconfont iconzdy"></i></b>
            <em>自定义首页</em>
          </a>
          <a href="javascript:;" @click="getNoticeShow">
            <b><i class="iconfont iconnotice"></i></b>
            <em>重要通知</em>
          </a>
        </div> -->
      </section>
      <main class="flexUI mainCon">
        <article class="leftWrap">
          <section class="flexUI topAncBox">
          <!-- S 待处理事项 -->
          <article class="pendingCon" v-if="pendInfo&&userInfoMd.exppower">
            <a href="javascript:;" class="pendingTit">
              <h4>待处理事项</h4>
              <span v-if="pendInfo.update_time">更新时间：{{dateTime(pendInfo.update_time,1)}}</span>
              <span class="orangeImpTip">待处理事项统计频率为30分钟一次，实时查看请 <em class="btnLoadNew" @click="pendingStatistics(1)"><i :class="pendInfoshow==true?'el-icon-refresh-left':'el-icon-loading'"></i>立即刷新</em>（实时数据以进入列表数据为准）</span>
            </a>
            <section class="pendingWrap">
              <!-- <div class="pendLeft"> -->
                <div class="orderWrap" v-if="pendInfo.order_matters">
                  <h4>订单事项</h4>
                  <ul>
                    <li>
                      <p>待发货自有订单</p>
                        <strong @click="toDelivery('/ShippedOrderList')"
                        >{{pendInfo.order_matters.dfhzydj | numFilter}}</strong>
                      <!-- <span>今日：12</span> -->
                    </li>
                    <li v-if="opendada==1">
                      <p>同城配送订单</p>
                      <router-link
                        :to="{path:'/IntraCityDistributionOrder'}"
                        tag="strong"
                      >{{isddordertotalnum | numFilter}}</router-link>
                      <!-- <span>今日：1</span> -->
                    </li>
                    <!-- <li>
                      <p>待打印快递</p>
                      <router-link :to="{path:'/ExpressPrintList'}" tag="strong">{{pendInfo.order_matters.ddykd | numFilter}}</router-link>

                    </li> -->
                   <!-- <li>
                      <p>快递漏单</p>
                      <router-link :to="{path:'/MissingExpressList'}" tag="strong">{{pendInfo.order_matters.kdld | numFilter}}</router-link>

                    </li> -->
                  </ul>
                </div>
                <div class="saleAfter stockWrap" v-if="ElementControls('jinshizun')==1&&userInfoMd.cantransferinv&&pendInfo.invcontrol_matters">
                  <h4>库存事项</h4>
                  <div class="saleCon">
                    <ul>
                      <li>
                        <p>调拨待审核</p>
                        <router-link :to="{name:'单品库存调拨记录',params:{singlecode: '0'},query:{status:0}}" tag="strong">{{pendInfo.invcontrol_matters.dbdsh}}</router-link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="cooperationWrap" :class="ElementControls('jinshizun')!=1||!pendInfo.invcontrol_matters?'wd50':''" v-if="pendInfo.cooperation_matters">
                  <h4>合作事项</h4>
                  <ul>
                    <li>
                      <p>待发货合作订单</p>
                      <strong @click="toDelivery('/ShippedOrderList')"
                      >{{pendInfo.cooperation_matters.dfhhzdd | numFilter}}</strong>
                      <!-- <span>今日：1</span> -->
                    </li>
                    <!-- <li>
                      <p>供应商额度预警</p>
                      <router-link :to="{path:'/EnterprManage'}"  tag="strong">{{pendInfo.cooperation_matters.gysedyj | numFilter}}</router-link>

                    </li>
                    <li>
                      <p>代销商额度预警</p>
                      <router-link :to="{path:'/EnterprManage',query:{cmpyType:'mySupply'}}"  tag="strong">{{pendInfo.cooperation_matters.dxsedyj | numFilter}}</router-link>

                    </li> -->
                  </ul>
                </div>
              <!-- </div> -->

             <!-- <div class="saleAfter" v-if="pendInfo.after_sale_matters">
                <h4>售后事项</h4>
                <div class="saleCon">
                  <ul>
                    <li>
                      <p>退换货申请</p>
                      <router-link :to="{path:'/AfterExchange'}" tag="strong">{{pendInfo.after_sale_matters.thhsq | numFilter}}</router-link>
                       <span>今日：12</span>
                    </li>
                    <li>
                      <p>快递补发申请</p>
                      <router-link :to="{path:'/AfterDelivery'}" tag="strong">{{pendInfo.after_sale_matters.dkbfsq | numFilter}}</router-link>
                      < <span>今日：--</span>
                    </li>
                    <li>
                      <p>意见建议</p>
                      <router-link :to="{path:'/AfterSuggestion'}" tag="strong">{{pendInfo.after_sale_matters.yjjy | numFilter}}</router-link>
                       <span>今日：--</span>
                    </li>
                    <li>
                      <p>消费者提问</p>
                      <router-link :to="{path:'/AfterConsumer'}" tag="strong">{{pendInfo.after_sale_matters.xfztw | numFilter}}</router-link>
                      <span>今日：--</span>
                    </li>
                  </ul>
                  <ul class="saleAfterUl">
                    <li>
                      <p>商品评价反馈</p>
                      <router-link :to="{path:'/AfterCommodityEvaluation?page=commodity'}" tag="strong">{{pendInfo.after_sale_matters.sppjfk | numFilter}}</router-link>
                       <span>今日：12</span>
                    </li>
                    <li>
                      <p>消费者提现申请</p>
                      <router-link :to="{path:'/AfterWithdraw'}" tag="strong">{{pendInfo.after_sale_matters.xfztxsq | numFilter}}</router-link>
                       <span>今日：12</span>
                    </li>
                    <li>
                      <p>有奖售后</p>
                      <router-link :to="{path:'/AfterAward'}" tag="strong">{{pendInfo.after_sale_matters.yjsh | numFilter}}</router-link>
                       <span>今日：12</span>
                    </li>
                  </ul>
                </div>
              </div> -->
            </section>
          </article>
          <!-- E 待处理事项 -->
           <!--S 内部公告-->
            <dl v-if="announceList.length>0" :class="{'ml20':pendInfo&&userInfoMd.exppower}">
              <dt class="flexBet">内部公告
                <router-link :to="{name:'门店内部公告'}" v-if="pagebBean.totalnum>5" class="mainColor">更多</router-link>
              </dt>
              <dd class="noticeBoxWrap" v-if="announceList.length>1">
                <p class="flexBet" v-for="(item,index) in announceList" :key="index" @click="getCommendShow(item.id,3)">
                  <span class="textFl" :title="item.title">{{item.title}}</span>
                  <small class="greyColor txtNoWrap"> {{dateTime(item.credate)}}</small>
                </p>
              </dd>
              <dd v-else class="noticeBoxWrap noticeInfoBox" @click="getCommendShow(announceList[0].id,3)">
                <h5>{{announceList[0].title}}</h5>
                <article v-html="showHtml"></article>
              </dd>
            </dl>
            <!--E 内部公告-->
            </section>
          <Transaction v-if="userInfoMd.isopeninvoice&&userInfoMd.objtype==0">
            <!-- S 礼品券卡概况 -->
            <article class="voucherCon" :class="{'none':!isTicketVal}" :slot="voucherCon">
              <a href="javascript:;" class="pendingTit" v-if="cardsInfo">
                <h4>礼品券卡概况</h4>
                <span>系统券卡出库总数
                  <a tag="b">
                    {{cardsInfo.total_out_num}}
                  </a>
                  张&nbsp;&nbsp;&nbsp;&nbsp;近7天券卡出库总数
                  <a tag="b">
                    {{cardsInfo.nearly_seven_days_num}}
                  </a>
                  张
                </span>
                <span v-if="cardsInfo.update_time">&nbsp;&nbsp;&nbsp;&nbsp;更新时间：{{dateTime(cardsInfo.update_time,1)}}</span>
              </a>
              <section class="companyWrap voucherWrap" v-if="cardsInfo">
                <el-tabs v-model="activeTicket">
                  <el-tab-pane label="全部券卡" name="0" class="allTicketTab">
                    <div class="dropCon">
                      <el-select v-model="cardsTime">
                        <el-option label="近30天" :value="0"></el-option>
                        <el-option label="近半年" :value="1"></el-option>
                        <el-option label="近一年" :value="2"></el-option>
                      </el-select>
                      <span>{{startCardsTime}} ~ {{nowQueryTime}}</span>
                    </div>
                    <p class="outNum" v-if="cardsInfo.out_info">
                      近{{cardsTime | timeStringFilter}}出库总数
                      <a  tag="b">
                        {{countTotal([
                          cardsInfo.out_info.unpaid_num,
                          cardsInfo.out_info.inactivated_num,
                          cardsInfo.out_info.unpicked_num,
                          cardsInfo.out_info.partial_delivery_num,
                          cardsInfo.out_info.picked_up_num,
                          cardsInfo.out_info.suspend_delivery_num,
                          cardsInfo.out_info.recycled_num,
                          cardsInfo.out_info.abolished_num,
                          cardsInfo.out_info.recycling_discount_num,
                        ])}}
                      </a>
                      张
                    </p>
                    <div ref="main" class="allMain"></div>
                  </el-tab-pane>
                  <el-tab-pane label="直接售卡" name="1">
                    <div class="dropCon">
                      <el-select v-model="cardsTime">
                        <el-option label="近30天" :value="0"></el-option>
                        <el-option label="近半年" :value="1"></el-option>
                        <el-option label="近一年" :value="2"></el-option>
                      </el-select>
                      <span>{{startCardsTime}} ~ {{nowQueryTime}}</span>
                    </div>
                    <p class="outNum" v-if="cardsInfo.out_info">
                      近{{cardsTime | timeStringFilter}}出库总数
                      <a tag="b">
                        {{countTotal([
                          cardsInfo.out_info.inactivated_num,
                          cardsInfo.out_info.unpicked_num,
                          cardsInfo.out_info.partial_delivery_num,
                          cardsInfo.out_info.picked_up_num,
                          cardsInfo.out_info.suspend_delivery_num,
                          cardsInfo.out_info.recycled_num,
                          cardsInfo.out_info.abolished_num,
                          cardsInfo.out_info.recycling_discount_num,
                        ])}}
                      </a>
                      张
                    </p>
                    <div ref="directMain" class="allMain"></div>
                  </el-tab-pane>
                  <!-- <el-tab-pane label="电商售卡" name="2">
                    <div class="dropCon">
                      <el-select v-model="cardsTime">
                        <el-option label="近30天" :value="0"></el-option>
                        <el-option label="近半年" :value="1"></el-option>
                        <el-option label="近一年" :value="2"></el-option>
                      </el-select>
                      <span>{{startCardsTime}} ~ {{nowQueryTime}}</span>
                    </div>
                    <p class="outNum" v-if="cardsInfo.out_info">
                      近{{cardsTime | timeStringFilter}}出库总数
                      <router-link :to="{path:'/CardRecordTotal'}" tag="b">
                        {{countTotal([
                          cardsInfo.out_info.inactivated_num,
                          cardsInfo.out_info.unpicked_num,
                          cardsInfo.out_info.partial_delivery_num,
                          cardsInfo.out_info.picked_up_num,
                          cardsInfo.out_info.suspend_delivery_num,
                          cardsInfo.out_info.recycled_num,
                          cardsInfo.out_info.abolished_num,
                        ])}}
                      </router-link>
                      张
                    </p>
                    <div ref="businessMain" class="allMain"></div>
                  </el-tab-pane> -->
                  <!-- <el-tab-pane label="分销售卡" name="3">
                    <div class="dropCon">
                      <el-select v-model="cardsTime">
                        <el-option label="近30天" :value="0"></el-option>
                        <el-option label="近半年" :value="1"></el-option>
                        <el-option label="近一年" :value="2"></el-option>
                      </el-select>
                      <span>{{startCardsTime}} ~ {{nowQueryTime}}</span>
                    </div>
                    <p class="outNum" v-if="cardsInfo.out_info">
                      近{{cardsTime | timeStringFilter}}出库总数
                      <router-link :to="{path:'/CardRecordTotal'}" tag="b">
                        {{countTotal([
                          cardsInfo.out_info.unpaid_num,
                          cardsInfo.out_info.unpicked_num,
                          cardsInfo.out_info.partial_delivery_num,
                          cardsInfo.out_info.picked_up_num,
                          cardsInfo.out_info.suspend_delivery_num,
                          cardsInfo.out_info.recycled_num,
                          cardsInfo.out_info.abolished_num,
                        ])}}
                      </router-link>
                      张
                    </p>
                    <div ref="saleMain" class="allMain"></div>
                  </el-tab-pane> -->
                </el-tabs>
              </section>
            </article>
            <!-- E 礼品券卡概况 -->
            <!-- S 订单概况 -->
            <article class="voucherCon" :class="{'none':!isOrderVal}" :slot="orderCon">
              <a href="javascript:;" class="pendingTit" v-if="orderInfo">
                <h4>订单概况</h4>
                <span>系统订单总数
                  <router-link :to="{path:'/AllOrder?status=0'}" tag="b">
                    {{orderInfo.total_order_num}}
                  </router-link>
                  单&nbsp;&nbsp;&nbsp;&nbsp;近30天新增订单总数
                  <router-link :to="{path:'/AllOrder?status=0'}" tag="b">
                    {{orderInfo.nearly_thirty_days_num}}
                  </router-link>
                  单
                </span>
                <span v-if="orderInfo.update_time">&nbsp;&nbsp;&nbsp;&nbsp;更新时间：{{dateTime(orderInfo.update_time,1)}}</span>
              </a>
              <section class="companyWrap voucherWrap" v-if="orderInfo">
                <el-tabs v-model="activeOrder">
                  <el-tab-pane label="全部订单" name="0" class="allTicketTab">
                    <div class="dropCon">
                      <el-select v-model="orderTime">
                        <el-option label="近30天" :value="0"></el-option>
                        <el-option label="近半年" :value="1"></el-option>
                        <el-option label="近一年" :value="2"></el-option>
                      </el-select>
                      <span>{{startOrderTime}} ~ {{nowQueryTime}}</span>
                    </div>
                    <p class="outNum" v-if="orderInfo.order_info">
                      近{{goodsTime | timeStringFilter}}新增订单
                      <router-link :to="{path:'/AllOrder?status=0'}" tag="b">
                        {{countTotal([
                          orderInfo.order_info.pending_payment_num,
                          orderInfo.order_info.pending_num,
                          orderInfo.order_info.distributing_num,
                          orderInfo.order_info.shipped_num,
                          orderInfo.order_info.partial_shipment_num,
                          orderInfo.order_info.normal_statement_num,
                          orderInfo.order_info.problem_statement_num,
                          orderInfo.order_info.refunded_num,
                          orderInfo.order_info.cancelled_num,
                        ])}}
                      </router-link>
                      单
                    </p>
                    <div ref="allOrderMain" class="allMain"></div>
                  </el-tab-pane>
                  <el-tab-pane label="自有订单" name="1">
                    <div class="dropCon">
                      <el-select v-model="orderTime">
                        <el-option label="近30天" :value="0"></el-option>
                        <el-option label="近半年" :value="1"></el-option>
                        <el-option label="近一年" :value="2"></el-option>
                      </el-select>
                      <span>{{startOrderTime}} ~ {{nowQueryTime}}</span>
                    </div>
                    <p class="outNum" v-if="orderInfo.order_info">
                      近{{goodsTime | timeStringFilter}}新增订单
                      <router-link :to="{path:'/AllOrder?status=0'}" tag="b">
                        {{countTotal([
                          orderInfo.order_info.pending_payment_num,
                          orderInfo.order_info.pending_num,
                          orderInfo.order_info.distributing_num,
                          orderInfo.order_info.shipped_num,
                          orderInfo.order_info.partial_shipment_num,
                          orderInfo.order_info.normal_statement_num,
                          orderInfo.order_info.problem_statement_num,
                          orderInfo.order_info.refunded_num,
                          orderInfo.order_info.cancelled_num,
                        ])}}
                      </router-link>
                      单
                    </p>
                    <div ref="selfOrderMain" class="allMain"></div>
                  </el-tab-pane>
                  <el-tab-pane label="代销订单" name="2">
                    <div class="dropCon">
                      <el-select v-model="orderTime">
                        <el-option label="近30天" :value="0"></el-option>
                        <el-option label="近半年" :value="1"></el-option>
                        <el-option label="近一年" :value="2"></el-option>
                      </el-select>
                      <span>{{startOrderTime}} ~ {{nowQueryTime}}</span>
                    </div>
                    <p class="outNum" v-if="orderInfo.order_info">
                      近{{goodsTime | timeStringFilter}}新增订单
                      <router-link :to="{path:'/AllOrder?status=0'}" tag="b">
                        {{countTotal([
                          orderInfo.order_info.pending_payment_num,
                          orderInfo.order_info.pending_num,
                          orderInfo.order_info.distributing_num,
                          orderInfo.order_info.shipped_num,
                          orderInfo.order_info.partial_shipment_num,
                          orderInfo.order_info.normal_statement_num,
                          orderInfo.order_info.problem_statement_num,
                          orderInfo.order_info.refunded_num,
                          orderInfo.order_info.cancelled_num,
                        ])}}
                      </router-link>
                      单
                    </p>
                    <div ref="saleOrderMain" class="allMain"></div>
                  </el-tab-pane>
                  <el-tab-pane label="被代销订单" name="3">
                    <div class="dropCon">
                      <el-select v-model="orderTime">
                        <el-option label="近30天" :value="0"></el-option>
                        <el-option label="近半年" :value="1"></el-option>
                        <el-option label="近一年" :value="2"></el-option>
                      </el-select>
                      <span>{{startOrderTime}} ~ {{nowQueryTime}}</span>
                    </div>
                    <p class="outNum" v-if="orderInfo.order_info">
                      近{{goodsTime | timeStringFilter}}新增订单
                      <router-link :to="{path:'/AllOrder?status=0'}" tag="b">
                        {{countTotal([
                          orderInfo.order_info.pending_payment_num,
                          orderInfo.order_info.pending_num,
                          orderInfo.order_info.distributing_num,
                          orderInfo.order_info.shipped_num,
                          orderInfo.order_info.partial_shipment_num,
                          orderInfo.order_info.normal_statement_num,
                          orderInfo.order_info.problem_statement_num,
                          orderInfo.order_info.refunded_num,
                          orderInfo.order_info.cancelled_num,
                        ])}}
                      </router-link>
                      单
                    </p>
                    <div ref="issaleMain" class="allMain"></div>
                  </el-tab-pane>
                </el-tabs>
              </section>
            </article>
            <!-- E 订单概况 -->
          </Transaction>
        </article>
        <article class="rightWrap" ref="rightRef">
          <!-- S 帮助文档 -->
          <section class="helpMode">
           <div class="helpTop helpWrap">
                         <el-tabs v-model="helpActive" class="helpTab">
                           <el-tab-pane label="公告" name="placard">
                               <ul v-show="companyheads.length>0" :class="{'noMore':totalnum<=5}">
                               <li @click="getCommendShow(items.anncode,2)" v-for="(items, index) in companyheads" :key="index"><b>【{{items.anntype | anntypesfiler}}】</b>{{items.anntitle}}</li>
                               </ul>
           									  <div v-if="companyheads.length<=0" class="noData">
           									    <span>暂无数据</span>
           									  </div>
                             <router-link v-if="totalnum>5" :to="{path:'/PlatformBulletin'}" class="helpLink">&nbsp;更多</router-link>
                           </el-tab-pane>
                           <el-tab-pane label="升级" name="upgrade">
           									<ul v-show="companyheads.length>0" :class="{'noMore':totalnum<=5}">
                               <li @click="getCommendShow(items.anncode,2)" v-for="(items, index) in companyheads" :key="index"><b>【{{items.anntype | anntypesfiler}}】</b>{{items.anntitle}}</li>
                               </ul>
           									  <div v-if="companyheads.length<=0" class="noData">
           									    <span>暂无数据</span>
           									  </div>
                             <router-link v-if="totalnum>5" :to="{path:'/PlatformBulletin'}" class="helpLink">&nbsp;更多</router-link>
                           </el-tab-pane>
                           <el-tab-pane label="维护" name="uphold">
           									<ul v-show="companyheads.length>0" :class="{'noMore':totalnum<=5}">
                               <li @click="getCommendShow(items.anncode,2)" v-for="(items, index) in companyheads" :key="index"><b>【{{items.anntype | anntypesfiler}}】</b>{{items.anntitle}}</li>
                               </ul>
           									  <div  v-if="companyheads.length<=0" class="noData">
           									    <span>暂无数据</span>
           									  </div>
                             <router-link v-if="totalnum>5" :to="{path:'/PlatformBulletin'}" class="helpLink">&nbsp;更多</router-link>
                           </el-tab-pane>
                           <el-tab-pane label="推广" name="extension">
           									<ul v-show="companyheads.length>0" :class="{'noMore':totalnum<=5}">
                               <li @click="getCommendShow(items.anncode,2)" v-for="(items, index) in companyheads" :key="index"><b>【{{items.anntype | anntypesfiler}}】</b>{{items.anntitle}}</li>
                               </ul>
           									  <div v-if="companyheads.length<=0" class="noData">
           									    <span>暂无数据</span>
           									  </div>
                             <router-link v-if="totalnum>5" :to="{path:'/PlatformBulletin'}" class="helpLink">&nbsp;更多</router-link>
                           </el-tab-pane>
                           <el-tab-pane label="其他" name="other">
           								<ul v-show="companyheads.length>0" :class="{'noMore':totalnum<=5}">
                               <li @click="getCommendShow(items.anncode,2)" v-for="(items, index) in companyheads" :key="index"><b>【{{items.anntype | anntypesfiler}}】</b>{{items.anntitle}}</li>
                               </ul>
           									  <div v-if="companyheads.length<=0" class="noData">
           									    <span>暂无数据</span>
           									  </div>
                             <router-link v-if="totalnum>5" :to="{path:'/PlatformBulletin'}" class="helpLink">&nbsp;更多</router-link>
                           </el-tab-pane>
                         </el-tabs>
                       </div>
                       <div class="helpTop">
                         <h3>帮助文档</h3>
                         <ul v-show="getDocumentinfoListHelp.length>0">
                           <li v-for="(item,index) in getDocumentinfoListHelp" :key="index" @click="getCommendShow(item.doccode,1)">{{index + 1}}、{{item.title}}</li>
                         </ul>
                         <div v-show="getDocumentinfoListHelp.length<=0" class="noData">
           								  <span>暂无数据</span>
           								</div>
                       </div>
            <div class="serviceWay">
              <h3>服务窗口<!-- <a href="http://cj.maboy.cn/index?khdm=&sysuid=3c0cfc16e4f14c5392f28df3409d87b8&cmpyname=" target="_blank">问题反馈&发布需求</a> --></h3>
             <!-- <button class="iconkf1">在线客服</button>
              <p>电话客服：0512-88886666</p> -->
        			<div class="ctatdiv" v-if="getOperinfos&&getOperinfos!=null">
        			  <p class="wbcd-tit">
        			    <span class="textFl" :title="getOperinfos.cmpyname">{{getOperinfos.cmpyname ||'---'}}</span>
        			    <em class="textFl" :title="getOperinfos.sername">{{getOperinfos.sername ||'---'}}</em>
        			  </p>
        			  <div class="ctatbox">
        			    <p>
        			      <i class="ico ico-tel"></i>
        			      <strong>{{getOperinfos.sertel ||'---'}}</strong>
        			    </p>
        			    <p>
        			      <i class="ico ico-qq"></i>
        			      <strong>{{getOperinfos.serqq ||'---'}}</strong>
        			    </p>
        			    <p>
        			      <i class="ico ico-wx"></i>
        			      <strong>{{getOperinfos.serwx||'---'}}</strong>
        			    </p>
        			    <span><img :src="getOperinfos.serwximg" onerror="this.src='https://presale.jhtsoft.com/picms/c47499b67d489.png'" /></span>
        			  </div>
        			</div>
            </div>
            <!-- <div class="helpTop helpApp">
              <h3>扫码下载礼盒营销APP</h3>
              <div>
                <a><img src="" onerror="this.src='https://presale.jhtsoft.com/picms/c47499b67d489.png'" alt="礼盒营销管理系统APP"></a>
                <p>
                  <span><i class="iconfont iconiOS"></i><b>IOS 版</b></span>
                  <em>随时随地，移动管控更安全、更便捷</em>
                </p>
              </div>
              <div>
                <a><img src="" onerror="this.src='https://presale.jhtsoft.com/picms/c47499b67d489.png'" alt="礼盒营销管理系统APP"></a>
                <p>
                  <span><i class="iconfont iconAndroid"></i><b>Android 版</b></span>
                  <em>随时随地，移动管控更安全、更便捷</em>
                </p>
              </div>
            </div> -->
          </section>
          <!-- E 帮助文档 -->
        </article>
      </main>
      <!-- S 弹框 -->
      <!-- S 自定义首页 -->
      <el-dialog title="自定义模块展示顺序" :visible.sync="moduleVisible" class="moduleDialog" append-to-body :close-on-click-modal="false">
        <h3>上下拖拽调整模块展示顺序，开关显示隐藏模块</h3>
        <section class="sortCon">
          <div class="sortImg">
            <p>
              <img src="https://presale.jhtsoft.com/picms/1e9c2215831.png" alt="礼盒营销">
            </p>
          </div>
          <div class="sortWrap">
            <ul class="sortItem">
              <li class="sortHigh">
                <i></i>
                <small>待处理事项</small>
              </li>
              <!-- {ghost-class} 拖动时的副本class -->
              <draggable
                  :disabled="!enabled"
                  ghost-class="ghost"
                  @end="onEnd"
                  animation="150"
                  v-model="myList"
                  >
                  <li v-for="(item,index) in myList" :key="index" :class="{'sortDouble':item.name=='仓分享'}">
                      <i></i>
                      <div class="sortSingle sortFirst" v-if="item.name=='仓分享'">
                          <small>{{item.name}}</small>
                          <el-switch v-model="item.bshow"> </el-switch>
                      </div>
                      <div class="sortSingle" v-if="item.name=='仓分享'">
                          <small>{{item.name1}}</small>
                          <el-switch v-model="item.bshow1"> </el-switch>
                      </div>
                      <small v-if="item.name!='仓分享'">{{item.name}}</small>
                      <el-switch v-if="item.name!='仓分享'" v-model="item.bshow"> </el-switch>
                  </li>
              </draggable>
            </ul>
            <ul class="sortShape">
              <li>
                <em></em>
                <b></b>
              </li>
              <li>
                <em></em>
                <b></b>
              </li>
              <li>
                <em></em>
                <b></b>
              </li>
              <li>
                <em></em>
                <b></b>
              </li>
            </ul>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveHomepageSet">确定</el-button>
            <el-button @click="closeModule">取消</el-button>
          </div>
        </section>
      </el-dialog>
      <!-- E 自定义首页 -->
      <!-- E 弹框 -->
      <!-- 回到顶部 -->
      <el-backtop target=".indexCon" :bottom="50">
        <div class="backTop">
          <i class="el-icon-caret-top"></i>
          <b>TOP</b>
        </div>
      </el-backtop>
    </el-main>
    <!-- footer -->
    <Footer></Footer>
      <!--S 帮助文档详情组件-->
    <HelpDetail :helpDetailBox="helpDetailShow" :doccode="doccode" :typesd="typesd" @closeHPBox="helpDetailShow = false"></HelpDetail>
    <!--E 帮助文档详情组件-->

  </el-container>
</template>
<script>
import draggable from "vuedraggable";
import api from '@/apis/api.js';
import Vue from 'vue';
import { mapState } from "vuex";
export default {
  name: "Index",
  data() {
    return {
      showqydm: false, // 是否跳转新的发货
      pendInfoshow:true,
      isddordertotalnum:0,
      doccode:'',
			typesd:0,
			totalnum:0,
			companyheads:[],
			getDocumentinfoListHelp:[],
			getDocumentinfoList:[],
			getOperinfos:'',
      transactionCon:"0",//仓分享、最新推荐模块-默认排在第一
      companyOverview:"1",//企业合作概况-默认排在第二
      shopOverview:'2',//商品合作概况-默认排在第三
      voucherCon:'3',//礼品券卡概况-默认排在第四
      orderCon:'4',//订单概况-默认排在第五
      // 轮播图
      swiperOption: {
        autoplay: {
          delay: 3000 //3秒切换一次
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        } //定义分页
      },
      activeManage: "proxyManage", //企业合作概况选中的tab,默认选中我是代销
      activeTicket: "0", //礼品券卡概况选中的tab,默认选中全部券卡
      activeOrder: "0", // 订单概况tab，默认选中全部订单
      moduleVisible: false, // 自定义首页弹窗
      isTransVal: true, //控制仓分享版块显隐
      isCommendVal: true, //控制最新推荐显隐
      isCooperationVal: true, //控制企业合作概况显隐
      isShopVal: true, //控制商品概况显隐
      isTicketVal: true, //控制礼品券卡概况显隐
      isOrderVal: true, //控制订单概况显隐
      enabled: true, //拖拽js
      dragging: false, //拖拽js
      // 帮助文档
      helpList: [
        {
          question:
            "商品管理相关帮助文档商品管理相关帮助文档商品管理相关帮助文档"
        },
        { question: "商品管理相关帮助文档" },
        { question: "商品管理相关帮助文档" },
        { question: "商品管理相关帮助文档" },
        { question: "商品管理相关帮助文档" }
      ],
      helpActive: "placard", // 帮助文档-默认选中公告
      topShow: false, //帮助文档盒子定位样式
      docScroll: "", //滚动条高度
      notifyInstance: "", //通知消息弹出框
      helpDetailShow:false,//查看帮助文档详情
      myList:[
        // {
        //   name:'仓分享',
        //   bshow:true,
        //   name1:'最新推荐',
        //   bshow1:true,
        // },
        // {
        //   name:'企业合作概况',
        //   bshow:true,
        // },
        // {
        //   name:'商品概况',
        //   bshow:true,
        // },
        {
          name:'礼品券卡概况',
          bshow:true,
        },
        {
          name:'订单概况',
          bshow:true,
        }
      ], // 操作的模块列表数据
      oldList: [], // 拖动之前的老数据
      // 开发时定义的变量
      userInfoMd: '', // 登录信息
      openSupplyper: 0, // 企业是否开通供方权限
      nowDateTime: '', // 当前的时间 年月日
      nowDateDay: '', // 当前的时间 星期几
      nowQueryTime: '', // 查询结束时间 当前时间
      startCooperateTime: '', // 查询开始时间 合作概括
      cooperateTime: 0, // 企业合作概况-我是供应下拉筛选框，默认0：近30天
      startGoodsTime: '', // 查询开始时间 商品概括
      goodsTime: 0, // 商品概括，默认0：近30天
      startCardsTime: '', // 查询开始时间 券卡概括
      cardsTime: 0, // 券卡概括，默认0：近30天
      startOrderTime: '', // 查询开始时间 订单概括
      orderTime: 0, // 订单概括，默认0：近30天
      pendInfo: '', // 待办事项信息
      cooperateInfo: '', // 合作统计信息
      goodsInfo: '', // 商品概括信息
      cardsInfo: '', // 券卡概括信息
      orderInfo: '', // 订单概括信息
      firstTrue: true, // 防止多次点击提交
      cmpyinfo:'',//企业信息
      valdate:'',//服务有效期
      opendada:0,
      isRuralVitalization: false,//是否是乡村振兴
      announceList:[],
      pagebBean:'',
    };
  },
  filters: {
    numFilter(val) {
      if(val) {
        return val;
      } else {
        return '--';
      }
    },
    timeStringFilter(val) {
      if(val == 0) {
        return '30天';
      } else if(val == 1) {
        return '半年';
      } else if(val == 2) {
        return '一年';
      }
    }
  },
  watch: {
		 "helpActive":function(val){
		      if(val=="placard"){ //公告
		         this.companyHead(-1)
		      }
		      if(val=="upgrade"){ //升级
		         this.companyHead(1)
		      }
		      if(val=="uphold"){ //维护
		         this.companyHead(0)
		      }
		      if(val=="extension"){ //推广
		         this.companyHead(2)
		      }
		      if(val=="other"){ //其他
		         this.companyHead(3)
		      }
		    },
    // 切换合作角色
    activeManage(val) {
      this.cooperationStatistics();
    },
    // 查询合作开始时间
    cooperateTime(val) {
      this.startCooperateTime = this.handleQueryDate(val);
      this.cooperationStatistics();
    },
    // 查询商品开始时间
    goodsTime(val) {
      this.startGoodsTime = this.handleQueryDate(val);
      this.goodsStatistics();
    },
    // 切换券卡定义类型
    activeTicket(val) {
      this.cardsStatistics();
    },
    cardsTime(val) {
      this.startCardsTime = this.handleQueryDate(val);
      this.cardsStatistics();
    },
    // 切换订单类型
    activeOrder(val) {
      this.orderStatistics();
    },
    orderTime(val) {
      this.startOrderTime = this.handleQueryDate(this.orderTime);
      this.orderStatistics();
    },
    //更改皮肤
    updateSkin(val){
      this.$nextTick(() => {
        if(this.cardsInfo){
          this.onEcharts("券卡", "0");
        }
        if(this.orderInfo){
          this.onEcharts("订单", "0");
        }
      })
    }
  },
  //==================================== 组件 ===================================
  components: {
    draggable,
    Footer: resolve => require(["@/components/common/Footer.vue"], resolve),
    HelpDetail: resolve => require(["@/components/common/HelpDetail.vue"], resolve), //查看帮助详情组件
    Transaction: resolve => require(["@/components/Index/Transaction.vue"], resolve), //查看帮助详情组件
  },
  //==================================== 方法 ===================================
  methods: {
    getQydmList(){
      let cmpyinfo=''
      let qydmlist=''
      if(localStorage.getItem("cmpyinfo")){
        cmpyinfo = JSON.parse(localStorage.getItem("cmpyinfo"));
      }
      if(localStorage.getItem("qydmlist")){
        qydmlist = JSON.parse(localStorage.getItem("qydmlist"));
        localStorage.setItem('qydmlist',JSON.stringify(qydmlist))
        this.showqydm =qydmlist.includes(cmpyinfo.qydm)
      }else{
        api.GET_QYDMLIST().then((res) =>{
          if(res.data.status=="200"){
            qydmlist = res.data.data;
            localStorage.setItem('qydmlist',JSON.stringify(qydmlist))
            this.showqydm =qydmlist.includes(cmpyinfo.qydm)
          }
        })
      }
    },
    toDelivery(toPage) {
      let  toPath = toPage;
      if(toPage == '/ShippedOrderList') {
        // 列表是否发货备注优先
        let firstdeliverymemo = this.ElementControls('firstdeliverymemo');
        if(firstdeliverymemo.split('@')[0]=='1') {
          toPath = firstdeliverymemo.split('@')[1]
        }
      }
      if(this.showqydm) {
        toPath =  toPath;
      } else {
        if(toPath != '/MissingExpressList') {
          toPath = '/subDelivery' + toPath;
        } else {
          toPath = '/subDelivery/ExpressPrintList?ld=1';
        }
        
      }
      this.$router.push({
        path: toPath
      });
    },
   bbalist(){
    let params = {
        status:0,
        bbstype: 1,
        pageparam:{
            pagesize: 5, //每页条数
            currentpage: 1, //当前页数
        }
      }
      api.GET_BBSLIST(params).then((res) => {
        if(res.data.status == '200'){
          this.announceList = res.data.data;
          if(res.data.pagebean){
            this.pagebBean = res.data.pagebean
          }
        }
      })
    },
    //计算服务有效期
    getDuration(my_time,index) {
      let date = my_time;
      if(index&&index==1){
         let yydate = this.dateTime(my_time);
         let ss= yydate +' '+'23:59:59'
         date = new Date(ss).getTime()
      }
      let days    = date / 1000 / 60 / 60 / 24;
      let daysRound = Math.floor(days);
      return daysRound;
    },
    companyHead(index){
		      console.log(index,'opo')
		      let param ={
		          status:1,
		          pageparam:{
		               pagesize: 5, //每页条数
		               currentpage: 1, //当前页数
		          }
		      }
		      if(index!=-1){
		        Vue.set(param,'anntype',index)
		      }else{
		        Vue.set(param,'anntype',null)
		      }
		      api.COMPANYHEAD(param).then(res =>{
		         if(res.data.status=="200"&&res.data.data!=null){
		           this.companyheads = res.data.data;
		           this.totalnum = res.data.pagebean.totalnum;
		         }else{
		           this.totalnum = 0;
		           this.companyheads = [];
		         }
		      })
		    },
		    // 打开最新推荐弹窗
		    getCommendShow(doccode,type){
		      this.typesd = type;
		      this.doccode = doccode;
		      this.helpDetailShow = true;
		    },
    // 重要通知弹框
    getNoticeShow() {
      // 防止打开多个弹框
      if (this.notifyInstance) {
        this.notifyInstance.close();
      }
      // this.notifyInstance = this.$notify({
      //   title: "重要通知",
      //   iconClass: "iconfont iconnotice",
      //   customClass: "noticeWrap",
      //   message:
      //     "公告系统最最重要的通知公告系统最最重要的通知公告系统最最重要的通知",
      //   duration: 0
      // });
    },
    // 自定义首页弹框
    getModuleShow() {
      this.moduleVisible = true;
    },
    // 拖拽结束
    onEnd(evt){
      evt.preventDefault();
    },
    // 自定义首页弹框确定操作
    getTransModule(){
      this.oldList = [];
      this.myList.forEach((item,index) => {
        if(item.name == '仓分享'){
          this.transactionCon = String(index);//仓分享、最新推荐
          this.isTransVal = item.bshow;
          this.isCommendVal = item.bshow1;
        }else if(item.name == '企业合作概况'){
          this.companyOverview = String(index);//企业合作概况
          this.isCooperationVal = item.bshow;
        }else if(item.name == '商品概况'){
          this.shopOverview = String(index);//商品概况
          this.isShopVal = item.bshow;
        }else if(item.name == '礼品券卡概况'){
          this.voucherCon = String(index);//礼品券卡概况
          this.isTicketVal = item.bshow;
        }else if(item.name == '订单概况'){
          this.orderCon = String(index);//订单概况
          this.isOrderVal = item.bshow;
        }
      })
      this.oldList = this.oldList.concat(this.myList);
      setTimeout(() => {
        this.onEcharts('券卡',this.activeTicket);
        this.onEcharts('订单',this.activeOrder);
      }, 300);
      this.moduleVisible = false;
    },
    // 关闭自定义首页弹窗
    closeModule() {
      this.moduleVisible = false;
      this.myList = [];
      this.myList = this.myList.concat(this.oldList);
    },
    // 页面滑动改变帮助文档盒子位置
    onScroll() {
      if(this.$route.name == '首页'){
        this.docScroll = document.querySelector(".indexCon").scrollTop; //滚动条高度
        if (this.docScroll >= 190) {
          if(this.$refs.rightRef){
            this.$refs.rightRef.style.position = "fixed";
            this.$refs.rightRef.style.height = "95%";
            this.$refs.rightRef.style.top = "-10px";
            this.$refs.rightRef.style.right = "35px";
            this.$refs.rightRef.style.overflowY = "auto";
          }

          // this.topShow = true;
          // // 关闭重要通知弹框
          // if(this.notifyInstance) {
          //     this.notifyInstance.close();
          // }
        } else {
          if(this.$refs.rightRef){
            this.$refs.rightRef.style.position = "relative";
            this.$refs.rightRef.style.height = "auto";
            this.$refs.rightRef.style.top = "auto";
            this.$refs.rightRef.style.right = "auto";
            this.$refs.rightRef.style.overflowY = "hidden";
          }
          // this.topShow = false;
        }
      }
    },
    // ---------------------------- S echarts图表 ----------------------------
    onEcharts(name,type){
      // 引入 ECharts 主模块
      const echarts = require("echarts/lib/echarts");
      // 引入柱状图
      require("echarts/lib/chart/bar");
      // 引入提示框组件
      require("echarts/lib/component/tooltip");
      // 基于准备好的dom，初始化echarts实例
      let commonWidth = document.querySelector(".voucherWrap .el-tabs").offsetWidth;

      // 提示框的设置
      let tooltip = {
        trigger: "axis",
        // 鼠标悬浮时样式
        axisPointer: {
          type: "shadow",
          shadowStyle: {
            color: this.updateSkin == 2 ? "#24c424" : (this.updateSkin == 1 ? "#64AFFA" : "#ff9429"),
            opacity: 0.1,
            width: 40
          }
        },
        //提示框的内容
        formatter: (params) => {
          let result = "";
          let dotHtml =
            '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#F56262"></span>'; //小圆点
          params.forEach((item) => {
            result += `<p style='margin:0 0 10px 0;'>${this.startCardsTime} ~ ${this.nowQueryTime}</p>`;
            result +=
              dotHtml +
              " " +
              item.seriesName +
              item.name +
              "数: " +
              item.value +
              "</br>";
          });
          return result;
        },
        backgroundColor: "rgba(0,0,0,0.65)",
        padding: [15, 20],
        textStyle: {
          fontFamily: "Noto Sans S Chinese",
          fontSize: 14
        }
      };
      // 订单相关提示框的设置
      let tooltipOrder = {
        trigger: "axis",
        // 鼠标悬浮时样式
        axisPointer: {
          type: "shadow",
          shadowStyle: {
            color: this.updateSkin == 2 ? "#24c424" : (this.updateSkin == 1 ? "#64AFFA" : "#ff9429"),
            opacity: 0.1,
            width: 40
          }
        },
        //提示框的内容
        formatter: (params) => {
          let result = "";
          let dotHtml =
            '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#F56262"></span>'; //小圆点
          params.forEach((item) => {
            result += `<p style='margin:0 0 10px 0;'>${this.startOrderTime} ~ ${this.nowQueryTime}</p>`;
            result +=
              dotHtml +
              " " +
              item.seriesName +
              item.name +
              "订单: " +
              item.value +
              "</br>";
          });
          return result;
        },
        backgroundColor: "rgba(0,0,0,0.65)",
        padding: [15, 20],
        textStyle: {
          fontFamily: "Noto Sans S Chinese",
          fontSize: 14
        }
      };
      // 坐标相关设置
      let yAxis = {
        // 坐标轴样式
        axisLabel: {
          textStyle: {
            color: "#666",
            fontSize: "14",
            fontFamily: "Noto Sans S Chinese"
          },
          interval:0,//坐标文字显示完整
        },
        //坐标轴线
        axisLine: {
          lineStyle: {
            opacity: 0
          }
        },
        // 坐标轴刻度
        axisTick: {
          show: false
        },
        // 分隔线
        splitLine: {
          lineStyle: {
            type: "dashed", //虚线
            color: "#EBEEF5"
          }
        },
        // 横坐标轴样式
        xaxisLabel: {
          textStyle: {
            color: "#666",
            fontSize: "14",
            fontFamily: "Arial"
          }
        },
        // 图表的大小、位置
        grid: {
          width: "100%",
          height: "95%",
          left: "65px",
          top: "0"
        },
        gridNew: {
          width: "93%",
          height: "90%",
          left: "65px",
          top: "20px"
        }
      };
      if(name == '券卡') {
        if(type == 0) {
          let myWidth = this.$refs.main;
          myWidth.style.width = commonWidth + "px";
          const myChart = echarts.init(myWidth); // 全部券卡
          // 绘制图表-全部券卡
          myChart.setOption({
            // 提示框的设置
            tooltip: tooltip,
            // 纵坐标相关设置
            yAxis: {
              axisLabel: yAxis.axisLabel,
              axisLine: yAxis.axisLine,
              axisTick: yAxis.axisTick,
              // 坐标名
              data: [
                "回收折现",
                "已作废",
                "已回收",
                "暂停提货",
                "已提货",
                "部分提货",
                "未提货",
                "未激活",
                "未支付"
              ]
            },
            color: [this.updateSkin == 2 ? "#24c424" : (this.updateSkin == 1 ? "#64AFFA" : "#ff9429")], // 柱子的颜色
            // 横坐标相关设置
            xAxis: {
              //坐标轴线
              axisLine: yAxis.axisLine,
              // 分隔线
              splitLine: yAxis.splitLine,
              // 坐标轴刻度
              axisTick: yAxis.axisTick,
              // 坐标轴样式
              axisLabel: yAxis.xaxisLabel
            },
            series: [
              {
                name: "礼品券卡",
                type: "bar",
                data: [
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.recycling_discount_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.abolished_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.recycled_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.suspend_delivery_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.picked_up_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.partial_delivery_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.unpicked_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.inactivated_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.unpaid_num:0
                ], // 坐标值
                barWidth: 30 //柱子的宽度
              }
            ],
            // 图表的大小、位置
            grid: yAxis.grid
          },true);
        } else if(type == 1) {
          let directWidth = this.$refs.directMain;
          directWidth.style.width = commonWidth + "px";
          const directChart = echarts.init(directWidth); // 直接售卡
          // 绘制图表-直接售卡
          directChart.setOption({
            // 提示框的设置
            tooltip: tooltip,
            // 纵坐标相关设置
            yAxis: {
              axisLabel: yAxis.axisLabel,
              axisLine: yAxis.axisLine,
              axisTick: yAxis.axisTick,
              // 坐标名
              data: [
                "回收折现",
                "已作废",
                "已回收",
                "暂停提货",
                "已提货",
                "部分提货",
                "未提货",
                "未激活"
              ]
            },
            color: [this.updateSkin == 2 ? "#24c424" : (this.updateSkin == 1 ? "#64AFFA" : "#ff9429")], // 柱子的颜色
            // 横坐标相关设置
            xAxis: {
              //坐标轴线
              axisLine: yAxis.axisLine,
              // 分隔线
              splitLine: yAxis.splitLine,
              // 坐标轴刻度
              axisTick: yAxis.axisTick,
              // 坐标轴样式
              axisLabel: yAxis.xaxisLabel
            },
            series: [
              {
                name: "礼品券卡",
                type: "bar",
                data: [
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.recycling_discount_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.abolished_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.recycled_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.suspend_delivery_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.picked_up_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.partial_delivery_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.unpicked_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.inactivated_num:0,
                ], // 坐标值
                barWidth: 30 //柱子的宽度
              }
            ],
            // 图表的大小、位置
            grid: yAxis.grid
          },true);
        } else if(type == 2) {
          let businessWidth = this.$refs.businessMain;
          businessWidth.style.width = commonWidth + "px";
          const businessChart = echarts.init(businessWidth); // 电商售卡
          // 绘制图表-电商售卡
          businessChart.setOption({
            // 提示框的设置
            tooltip: tooltip,
            // 纵坐标相关设置
            yAxis: {
              axisLabel: yAxis.axisLabel,
              axisLine: yAxis.axisLine,
              axisTick: yAxis.axisTick,
              // 坐标名
              data: ["已作废", "已回收", "暂停提货", "已提货", "部分提货", "未提货","未激活"]
            },
            color: [this.updateSkin == 2 ? "#24c424" : (this.updateSkin == 1 ? "#64AFFA" : "#ff9429")], // 柱子的颜色
            // 横坐标相关设置
            xAxis: {
              //坐标轴线
              axisLine: yAxis.axisLine,
              // 分隔线
              splitLine: yAxis.splitLine,
              // 坐标轴刻度
              axisTick: yAxis.axisTick,
              // 坐标轴样式
              axisLabel: yAxis.xaxisLabel
            },
            series: [
              {
                name: "礼品券卡",
                type: "bar",
                data: [
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.abolished_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.recycled_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.suspend_delivery_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.picked_up_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.partial_delivery_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.unpicked_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.inactivated_num:0,
                ], // 坐标值
                barWidth: 30 //柱子的宽度
              }
            ],
            // 图表的大小、位置
            grid: yAxis.grid
          },true);
        } else if(type == 3) {
          let saleWidth = this.$refs.saleMain;
          saleWidth.style.width = commonWidth + "px";
          const saleChart = echarts.init(saleWidth); // 分销售卡
          // 绘制图表-分销售卡
          saleChart.setOption({
            // 提示框的设置
            tooltip: tooltip,
            // 纵坐标相关设置
            yAxis: {
              axisLabel: yAxis.axisLabel,
              axisLine: yAxis.axisLine,
              axisTick: yAxis.axisTick,
              // 坐标名
              data: [
                "已作废",
                "已回收",
                "暂停提货",
                "已提货",
                "部分提货",
                "未提货",
                "未支付"
              ]
            },
            color: [this.updateSkin == 2 ? "#24c424" : (this.updateSkin == 1 ? "#64AFFA" : "#ff9429")], // 柱子的颜色
            // 横坐标相关设置
            xAxis: {
              //坐标轴线
              axisLine: yAxis.axisLine,
              // 分隔线
              splitLine: yAxis.splitLine,
              // 坐标轴刻度
              axisTick: yAxis.axisTick,
              // 坐标轴样式
              axisLabel: yAxis.xaxisLabel
            },
            series: [
              {
                name: "礼品券卡",
                type: "bar",
                data: [
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.abolished_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.recycled_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.suspend_delivery_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.picked_up_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.partial_delivery_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.unpicked_num:0,
                  this.cardsInfo&&this.cardsInfo.out_info?this.cardsInfo.out_info.unpaid_num:0
                ], // 坐标值
                barWidth: 30 //柱子的宽度
              }
            ],
            // 图表的大小、位置
            grid: yAxis.grid
          });
        }
      } else {
        let nameList = [
          "待付款",
          "已付款/ 待处理",
          "配货中",
          "已发货",
          "部分发货",
          "正常结单",
          "问题结单",
          "已退款",
          "已取消"
        ];
        let dataList = [
          this.orderInfo&&this.orderInfo.order_info?this.orderInfo.order_info.pending_payment_num:0,
          this.orderInfo&&this.orderInfo.order_info?this.orderInfo.order_info.pending_num:0,
          this.orderInfo&&this.orderInfo.order_info?this.orderInfo.order_info.distributing_num:0,
          this.orderInfo&&this.orderInfo.order_info?this.orderInfo.order_info.shipped_num:0,
          this.orderInfo&&this.orderInfo.order_info?this.orderInfo.order_info.partial_shipment_num:0,
          this.orderInfo&&this.orderInfo.order_info?this.orderInfo.order_info.normal_statement_num:0,
          this.orderInfo&&this.orderInfo.order_info?this.orderInfo.order_info.problem_statement_num:0,
          this.orderInfo&&this.orderInfo.order_info?this.orderInfo.order_info.refunded_num:0,
          this.orderInfo&&this.orderInfo.order_info?this.orderInfo.order_info.cancelled_num:0,
        ];
        if(this.ElementControls('auditCancelOrder')==1) {
          nameList.push("订单取消待审核");
          dataList.push(this.orderInfo && this.orderInfo.order_info? this.orderInfo.order_info.cancellapply_num : 0);
        }
        if(type == 0) {
          let allWidth = this.$refs.allOrderMain;
          allWidth.style.width = commonWidth + "px";
          const allOrderChart = echarts.init(allWidth); // 全部订单
          // 绘制图表-全部订单
          allOrderChart.setOption({
            // 提示框的设置
            tooltip: tooltipOrder,
            // 横坐标相关设置
            xAxis: {
              axisLabel: yAxis.axisLabel,
              axisLine: yAxis.axisLine,
              axisTick: yAxis.axisTick,
              // 坐标名
              data: nameList
            },
            color: [this.updateSkin == 2 ? "#24c424" : (this.updateSkin == 1 ? "#64AFFA" : "#ff9429")], // 柱子的颜色
            // 纵坐标相关设置
            yAxis: {
              //坐标轴线
              axisLine: yAxis.axisLine,
              // 分隔线
              splitLine: yAxis.splitLine,
              // 坐标轴刻度
              axisTick: yAxis.axisTick,
              // 坐标轴样式
              axisLabel: yAxis.xaxisLabel
            },
            series: [
              {
                name: "",
                type: "bar",
                data: dataList, // 坐标值
                barWidth: 60 //柱子的宽度
              }
            ],
            // 图表的大小、位置
            grid: yAxis.gridNew
          },true);
        } else if(type == 1) {
          let selfWidth = this.$refs.selfOrderMain;
          selfWidth.style.width = commonWidth + "px";
          const selfOrderChart = echarts.init(selfWidth); // 自有订单
          // 绘制图表-自有订单
          selfOrderChart.setOption({
            // 提示框的设置
            tooltip: tooltipOrder,
            // 横坐标相关设置
            xAxis: {
              axisLabel: yAxis.axisLabel,
              axisLine: yAxis.axisLine,
              axisTick: yAxis.axisTick,
              // 坐标名
              data: nameList
            },
            color: [this.updateSkin == 2 ? "#24c424" : (this.updateSkin == 1 ? "#64AFFA" : "#ff9429")], // 柱子的颜色
            // 纵坐标相关设置
            yAxis: {
              //坐标轴线
              axisLine: yAxis.axisLine,
              // 分隔线
              splitLine: yAxis.splitLine,
              // 坐标轴刻度
              axisTick: yAxis.axisTick,
              // 坐标轴样式
              axisLabel: yAxis.xaxisLabel
            },
            series: [
              {
                name: "",
                type: "bar",
                data: dataList, // 坐标值
                barWidth: 60 //柱子的宽度
              }
            ],
            // 图表的大小、位置
            grid: yAxis.gridNew
          },true);
        } else if(type == 2) {
          let saleOrderWidth = this.$refs.saleOrderMain;
          saleOrderWidth.style.width = commonWidth + "px";
          const saleOrderChart = echarts.init(this.$refs.saleOrderMain); // 代销订单
          // 绘制图表-代销订单
          saleOrderChart.setOption({
            // 提示框的设置
            tooltip: tooltipOrder,
            // 横坐标相关设置
            xAxis: {
              axisLabel: yAxis.axisLabel,
              axisLine: yAxis.axisLine,
              axisTick: yAxis.axisTick,
              // 坐标名
              data: nameList
            },
            color: [this.updateSkin == 2 ? "#24c424" : (this.updateSkin == 1 ? "#64AFFA" : "#ff9429")], // 柱子的颜色
            // 纵坐标相关设置
            yAxis: {
              //坐标轴线
              axisLine: yAxis.axisLine,
              // 分隔线
              splitLine: yAxis.splitLine,
              // 坐标轴刻度
              axisTick: yAxis.axisTick,
              // 坐标轴样式
              axisLabel: yAxis.xaxisLabel
            },
            series: [
              {
                name: "",
                type: "bar",
                data: dataList, // 坐标值
                barWidth: 60 //柱子的宽度
              }
            ],
            // 图表的大小、位置
            grid: yAxis.gridNew
          },true);
        } else if(type == 3) {
          let issaleOrderWidth = this.$refs.issaleMain;
          issaleOrderWidth.style.width = commonWidth + "px";
          const issaleOrderChart = echarts.init(issaleOrderWidth); // 被代销订单
          // 绘制图表-被代销订单
          issaleOrderChart.setOption({
            // 提示框的设置
            tooltip: tooltipOrder,
            // 横坐标相关设置
            xAxis: {
              axisLabel: yAxis.axisLabel,
              axisLine: yAxis.axisLine,
              axisTick: yAxis.axisTick,
              // 坐标名
              data: nameList
            },
            color: [this.updateSkin == 2 ? "#24c424" : (this.updateSkin == 1 ? "#64AFFA" : "#ff9429")], // 柱子的颜色
            // 纵坐标相关设置
            yAxis: {
              //坐标轴线
              axisLine: yAxis.axisLine,
              // 分隔线
              splitLine: yAxis.splitLine,
              // 坐标轴刻度
              axisTick: yAxis.axisTick,
              // 坐标轴样式
              axisLabel: yAxis.xaxisLabel
            },
            series: [
              {
                name: "",
                type: "bar",
                data: dataList, // 坐标值
                barWidth: 60 //柱子的宽度
              }
            ],
            // 图表的大小、位置
            grid: yAxis.gridNew
          },true);
        }
      }
      // ---------------------------- E echarts图表 ----------------------------
    },
    // 后台数据处理 ------------------------------------------------------------------------------ 后台数据处理
    // 处理当前时间
    handleNowDate() {
      let nowD = new Date();
      let timestamp = nowD.getTime();
      this.nowDateTime = this.dateTime(timestamp,0,'年月日');
      this.nowQueryTime = this.dateTime(timestamp);
      let days = nowD.getDay();
      switch (days) {
        case 1:
          this.nowDateDay = '星期一';
          break;
        case 2:
          this.nowDateDay = '星期二';
          break;
        case 3:
          this.nowDateDay = '星期三';
          break;
        case 4:
          this.nowDateDay = '星期四';
          break;
        case 5:
          this.nowDateDay = '星期五';
          break;
        case 6:
          this.nowDateDay = '星期六';
          break;
        case 0:
          this.nowDateDay = '星期日';
          break;
      }
    },
    // 处理查询时间
    handleQueryDate(type) {
      let nowD = new Date();
      let timestamp = nowD.getTime();
      let startTamp = timestamp - 30*24*60*60*1000;
      if(type == 1) {
        startTamp = timestamp - 180*24*60*60*1000;
      } else if (type == 2) {
        startTamp = timestamp - 365*24*60*60*1000;
      }
      return this.dateTime(startTamp);
    },
    // 待处理事项数量统计
    pendingStatistics(type) {
      if(!this.pendInfoshow){
       return
      }
      this.pendInfoshow = false;
      let params = {}; 
      if(type == 1) {
        params.isnew = 1;
      }
      api.PENDINGSTATISTICS(params).then(res => {
        if(res.data.status == "200") {
          this.pendInfoshow = true
          if(res.data.data && res.data.data != 'null') {
            this.pendInfo = res.data.data;
          }
        }else{
          this.pendInfoshow = true
        }
      }).catch((err)=>{
        this.pendInfoshow = true
      })
    },
    // 获取合作企业统计信息
    cooperationStatistics() {
      let cooperParams = {
        type: this.activeManage == "proxyManage"?1:0,
        sdate: this.startCooperateTime,
        edate: this.nowQueryTime
      }
      api.COOPERATIONSTATISTICS(cooperParams).then(res => {
        if(res.data.status == "200") {
          if(res.data.data && res.data.data != 'null') {
            this.cooperateInfo = res.data.data;
          }
        }
      })
    },
    // 商品概况统计
    goodsStatistics() {
      let goodsParams = {
        sdate: this.startGoodsTime,
        edate: this.nowQueryTime
      }
      api.GOODSSTATISTICS(goodsParams).then(res => {
        if(res.data.status == "200") {
          if(res.data.data && res.data.data != 'null') {
            this.goodsInfo = res.data.data;
          }
        }
      })
    },
    // 礼品券卡概况统计
    cardsStatistics() {
      let cardParams = {
        type: Number(this.activeTicket),
        sdate: this.startCardsTime,
        edate: this.nowQueryTime
      }
      api.CARDSSTATISTICS(cardParams).then(res => {
        if(res.data.status == '200') {
          if(res.data.data && res.data.data !='null') {
            this.cardsInfo = res.data.data;
            setTimeout(() => {
              this.onEcharts('券卡',this.activeTicket);
            },300)
          }
        }
      })
    },
    // 订单概况统计
    orderStatistics() {
      let orderParams = {
        type: Number(this.activeOrder),
        sdate: this.startOrderTime,
        edate: this.nowQueryTime
      }
      api.ORDERSTATISTICS(orderParams).then(res => {
        if(res.data.status == "200") {
          if(res.data.data && res.data.data != 'null') {
            this.orderInfo = res.data.data;
            setTimeout(() => {
              this.onEcharts('订单',this.activeOrder);
            },300)
          }
        }
      })
    },
    // 计算总和
    countTotal(arr) {
      let num = 0;
      if(arr.length>0) {
        arr.forEach(item => {
          if(item) {
            num = num + item;
          }
        })
      }
      return num;
    },
    // 获取首页自定义设置
    getHomepageSet() {
      api.GET_HOMEPAGESET({}).then(res => {
        if(res.data.status == "200") {
          if(res.data.data && res.data.data != 'null' && res.data.data.length>0) {
            let homeList = res.data.data;
            let info = {};
            this.myList = [];
            homeList.forEach((item,index) => {
              if(item.name == 'sharing') {
                info = {
                  name: '仓分享',
                  name1: '最新推荐',
                  bshow: item.bshow?true:false,
                  bshow1: true
                }
                this.myList[item.index] = info;
                this.transactionCon = String(item.index);//仓分享、最新推荐
                this.isTransVal = item.bshow?true:false;
              }else if(item.name == 'recommended') {
                this.myList[item.index].bshow1 = item.bshow?true:false;
                this.isCommendVal = item.bshow?true:false;
              } else if(item.name == 'cooperation') {
                info = {
                  name: '企业合作概况',
                  bshow: item.bshow?true:false,
                }
                this.myList[item.index] = info;
                this.companyOverview = String(item.index);//企业合作概况
                this.isCooperationVal = item.bshow?true:false;
              } else if(item.name == 'goods') {
                info = {
                  name: '商品概况',
                  bshow: item.bshow?true:false,
                }
                this.myList[item.index] = info;
                this.shopOverview = String(item.index);//商品概况
                this.isShopVal = item.bshow?true:false;
              } else if(item.name == 'cards') {
                info = {
                  name: '礼品券卡概况',
                  bshow: item.bshow?true:false,
                }
                this.myList[item.index] = info;
                this.voucherCon = String(item.index);//礼品券卡概况
                this.isTicketVal = item.bshow?true:false;
              } else if(item.name == 'order') {
                info = {
                  name: '订单概况',
                  bshow: item.bshow?true:false,
                }
                this.myList[item.index] = info;
                this.orderCon = String(item.index);//订单概况
                this.isOrderVal = item.bshow?true:false;
              }
            });
            this.oldList = this.oldList.concat(this.myList);
          }
        }
      })
    },
    // 保存首页自定义设置
    saveHomepageSet() {
      if(this.firstTrue) {
        let homeData = [];
        let info = {};
        this.myList.forEach((item,index) => {
          if(item.name == '仓分享') {
            info = {
              name: 'sharing',
              index: index,
              bshow: item.bshow?1:0,
            };
            homeData.push(info);
            info = {
              name: 'recommended',
              index: index,
              bshow: item.bshow1?1:0,
            };
            homeData.push(info);
          } else if(item.name == '企业合作概况') {
            info = {
              name: 'cooperation',
              index: index,
              bshow: item.bshow?1:0,
            };
            homeData.push(info);
          } else if(item.name == '商品概况') {
            info = {
              name: 'goods',
              index: index,
              bshow: item.bshow?1:0,
            };
            homeData.push(info);
          } else if(item.name == '礼品券卡概况') {
            info = {
              name: 'cards',
              index: index,
              bshow: item.bshow?1:0,
            };
            homeData.push(info);
          }else if(item.name == '订单概况') {
            info = {
              name: 'order',
              index: index,
              bshow: item.bshow?1:0,
            };
            homeData.push(info);
          }
        });
        this.firstTrue = false;
        api.SAVEHOMEPAGESET({data:homeData}).then(res => {
          this.firstTrue = true;
          if(res.data.status == "200") {
            this.$message({
              type: "success",
              message: res.data.message
            });
            this.getTransModule();
          } else {
            this.$message({
              type: "error",
              message: res.data.message
            })
          }
        }).catch(res => {
          this.firstTrue = true;
        })
      }
    },
		getOperinfo(){
      if(localStorage.getItem("getOperinfos")){
        this.getOperinfos = JSON.parse(localStorage.getItem("getOperinfos"));
      }else{
        api.GET_OPERINFO().then(res =>{
		        if(res.data.status=="200"){
		          this.getOperinfos = res.data.data;
              localStorage.setItem('getOperinfos', JSON.stringify(res.data.data));
		        }
		    })
      }
    },
    //帮助文档
    getDocumentinfoListsHelp(){
      let categorycode = api.GET_HELP;
      if(categorycode.indexcode==''){
         return
      }
      let param ={
             type:0,
             status:1,
             categorycode:categorycode.indexcode,
          //    pageparam:{
          //       pagesize:5, //每页条数
          //       currentpage: 1, //当前页数
          // }
      }
      api.GET_DOCUMENTINFOLIST(param).then(res =>{
        if(res.data.status=="200"&&res.data.data!=null){
           this.getDocumentinfoListHelp = res.data.data;
        }else{
          this.getDocumentinfoListHelp =[];
        }
      })
    },
    getIntraCityServiceOrderBaseList(){
      api.GETINTRACITYSERVICEORDERBASELIST({isddorder:1,gtype:0,handlercode:''}).then(res =>{
         if(res.data.status=="200"){
           this.isddordertotalnum = res.data.pagebean.totalnum
         }else{
           this.isddordertotalnum=0;
         }
      })
    }
  },
  //==================================== 生命周期 ===================================
  mounted() {
    this.getQydmList()
    if(this.returnDomain()) {
      this.isRuralVitalization = true;
    }
    this.getIntraCityServiceOrderBaseList();
    if(this.ElementControls('opendada').includes('@')) {
      let lists = this.ElementControls('opendada').split('@')
          this.opendada =lists[0]
    }
    if(localStorage.getItem("cmpyinfo")){
      this.cmpyinfo = JSON.parse(localStorage.getItem("cmpyinfo"));
      this.valdate = this.cmpyinfo.valdate;
    }
    this.companyHead(-1);
		this.getDocumentinfoListsHelp();
    // 获取当前时间
    this.handleNowDate();
		this.getOperinfo();
    // 处理查询时间
    this.startCooperateTime = this.handleQueryDate(0);
    this.startGoodsTime = this.handleQueryDate(0);
    this.startCardsTime = this.handleQueryDate(0);
    this.startOrderTime = this.handleQueryDate(0);
    // 获取登录信息
    if(localStorage.getItem('userInfoMd')) {
      this.userInfoMd = JSON.parse(localStorage.getItem('userInfoMd'));
      // 获取代办事项信息
      this.pendingStatistics();
      this.bbalist();
      // 获取首页自定义设置
      this.getHomepageSet();
      setTimeout(() => {
        if(localStorage.getItem('opensupplyper')) {
          this.openSupplyper = 1;
          this.activeManage = 'supplyManage';
        } else {
          this.cooperationStatistics();
        }
      },300)
      // 商品概况统计
      this.goodsStatistics();
      // 礼品券卡概况统计
      this.cardsStatistics()
      // 订单概况统计
      this.orderStatistics()
    }
    // 重要通知弹框
    this.getNoticeShow();
    // 监听页面滑动
    if(this.$route.name == '首页'){
      window.addEventListener("scroll", this.onScroll, true);
    }
    // 渲染Echarts图表
    setTimeout(() => {
      // 调用首页的遮罩引导，需要做判断，实际开发中用localstrorage判断只展示一次
      if(!localStorage.getItem("firstStep")){
        getStep(0);
      }
    }, 800);
  },
  created() {
    // 防止火狐浏览器下拖拽排序时打开新页面
    document.body.ondrop = function(event) {
      event.preventDefault();
      event.stopPropagation();
    };
  },

  destroyed() {
    // 离开当前页面时关闭重要通知弹框
    if (this.notifyInstance) {
      this.notifyInstance.close();
    }
  },
  computed: {
    ...mapState({
      updateSkin: ({ common }) => common.updateSkin,
    }),
    showHtml() {
      return this.announceList[0].bbscontent
        .replace(this.announceList[0].bbscontent ? /&(?!#?\w+;)/g : /&/g, "&amp;")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&amp;nbsp;/g, " ")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&nbsp;/g, " ");
    },
  }
};
</script>
<style scoped>
@import "../../assets/css/common.css";
h3,
h4,
h5,
strong {
  font-weight: bold;
}
a:hover {
  color: initial;
}
.indexCon{
  overflow-y: auto;
}
.el-main {
  padding: 20px 30px 40px 20px;
  background: #f6f8fb;
  min-height: calc(100vh - 50px);
  line-height: 1.5;
  color: #333;
  font-size: 14px;
}
.userCon,
.pendingWrap,
.pendingWrap ul,
.transactionCon,
.marketBanner,
.marketBanner .swiper-container .swiper-slide,
.commendBanner a,
.commendBanner,
.supplyCon,
.supplyCon ul,
.kindWrap li:last-child,
.sortWrap,
.sortItem li,
.sortItem li .sortSingle,
.helpApp div,
.helpApp div p span {
  display: -webkit-flex;
  display: -moz-flex;
  display: -o-flex;
  display: -ms-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -o-align-items: center;
  -ms-align-items: center;
  align-items: center;
}
.userCon,
.transactionCon,
.commendBanner,
.supplyCon,
.kindWrap,
.sortItem li,
.sortItem li .sortSingle,
.mainCon {
  -webkit-justify-content: space-between;
  -moz-justify-content: space-between;
  -ms-justify-content: space-between;
  -o-justify-content: space-between;
  justify-content: space-between;
}
.leftWrap {
  width: calc(100% - 300px);
}
.commendBanner {
  -o-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}
.noticeCon {
  -ms-align-self: flex-end;
  -o-align-self: flex-end;
  -moz-align-self: flex-end;
  -webkit-align-self: flex-end;
  align-self: flex-end;
}
.noticeCon a{
  color: #333;
}
.marketBanner >>> .swiper-slide,
.commendBanner a {
  -o-justify-content: center;
  -ms-justify-content: center;
  -moz-justify-content: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.commendBanner a {
  -o-flex-direction: column;
  -ms-flex-direction: column;
  -moz-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
}
.saleAfter,
.supplyCon .supplyWrap,
.rightWrap,
.helpApp div p {
  -o-align-self: flex-start;
  -ms-align-self: flex-start;
  -moz-align-self: flex-start;
  -webkit-align-self: flex-start;
  align-self: flex-start;
}
.marketBanner,
.commendBanner,
.supplyCon .supplyWrap,
.helpMode,
.sortItem li,
.sortShape li,
.commendBanner a {
  -ms-box-sizing: border-box;
  -o-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.userCon {
  color: #333;
  font-size: 14px;
  line-height: 1.5;
}
.userWrap h3 {
  font-size: 24px!important;
  font-weight: normal;
}
.userWrap h3 > span {font-size:16px;}
.userWrap h3 .fwBold {font-size:20px; padding:0 5px;}
.userWrap span {
  color: #666;
}
.noticeCon a:first-child {
  margin-right: 50px;
}
.noticeCon a:hover {
  color: var(--main-color);
}
.noticeCon a:hover b {
  border: 1px solid var(--main-color);
}
.noticeCon b {
  width: 40px;
  height: 40px;
  line-height: 40px;
  -o-border-radius: 50%;
  -ms-border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  border: 1px solid #dcdfe6;
  display: inline-block;
  text-align: center;
  margin-right: 14px;
}
/* S 待处理事项 */
.pendingCon,
.rightWrap {
  margin-top: 20px;
}
.noticeCon b i {
  font-size: 20px;
}
.noticeCon em {
  font-weight: bold;
}
.pendingTit h4,
.transactionCon h4 {
  display: inline-block;
  font-size: 18px;
  margin-right: 20px;
  color: #333;
}
.pendingTit h4:hover {
  color: initial;
}
.pendingTit span {
  font-size: 14px;
  color: #999;
}
.pendingWrap,
.marketBanner,
.commendBanner,
.companyWrap,
.sortCon .sortImg,
.sortItem li,
.sortShape li {
  -webkit-box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.06);
  -moz-box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.06);
  -ms-box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.06);
  -o-box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.06);
  box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.06);
  background: #fff;
  margin-top: 15px;
  padding: 15px 20px 15px 20px;
}
.pendingWrap h4 {
  display: inline-block;
  line-height: 26px;
}
.pendLeft,
.saleAfter{
  width:50%;
}
.orderWrap h4 {
  color: #F7615E;
  border-bottom: 2px solid #F56262;
}
.orderWrap ul {
  border-top: 1px solid #fceded;
}
.orderWrap .el-icon-refresh-left,.el-icon-loading {
  color: var(--main-color);
  font-size: 16px;
  padding: 0 10px;
  cursor: pointer;
}
.cooperationWrap h4 {
  color: var(--main-color);
  border-bottom: 2px solid var(--main-color);
}
.cooperationWrap ul {
  border-top: 1px solid #edf5ff;
}
.orderWrap{flex:1 1 calc(50% - 20px);margin-right:20px;}
.orderWrap ul li{width:50%;}
.cooperationWrap,.stockWrap{flex:1 1 calc(25% - 20px);margin-right: 20px;}
.wd50{width:50%!important}
.pendingWrap{justify-content: space-between;flex-wrap: wrap;}
.saleCon:hover{
  background:#fafafa;
}
.pendLeft{
  margin-right:10px;
}
.saleAfter h4 {
  color: #f2962c;
  border-bottom: 2px solid #f2962c;
}
.saleAfter ul {
  border-top: 1px solid #faecd8;
}
.saleAfter .saleAfterUl{
  margin-top:28px;
  border-top:none;
}
.pendingWrap ul {
  padding: 20px;
}
.pendingWrap ul li {
  width: 100%;
  margin-right:5px;
}
.pendingWrap ul:hover {
  background: #fafafa;
}
.pendingWrap ul li p {
  color: #999;
  white-space:nowrap;
}
.pendingWrap ul li strong {
  display: block;
  font-size: 28px;
  cursor: pointer;
  font-family: "PingFang SC", "Microsoft YaHei", Arial, Verdana;
}
.pendingWrap ul li strong:hover {
  color: var(--main-color);
}
.pendingWrap ul li span {
  display: block;
  color: #666;
}
.pendingWrap ul li span i {
  color: #c0c4cc;
  font-size: 14px;
  margin-left: 5px;
}
/* E 待处理事项 */
/* S 仓分享、最新推荐 */
.transactionCon,
.companyOverview,
.voucherCon {
  margin-top: 30px;
}
.marketWrap,
.recommendWrap {
  width: calc((100% - 20px) / 2);
}
.marketBanner,
.commendBanner {
  width: 100%;
  height: 350px;
}
.transactionCon img {
  max-width: 100%;
}
.marketBanner >>> .swiper-pagination-bullet {
  width: 20px;
  height: 4px;
  background: #fff;
  -o-border-radius: 0;
  -ms-border-radius: 0;
  -moz-border-radius: 0;
  -webkit-border-radius: 0;
  border-radius: 0;
  opacity: 0.6;
}
.marketBanner >>> .swiper-pagination-bullet-active {
  background: #fff;
  opacity: 1;
}
.commendBanner a {
  position: relative;
  overflow: hidden;
}
.commendBanner a::before {
  content: "";
  position: absolute;
  width: 55px;
  height: 55px;
  border-radius: 100%;
  background: #fff;
  opacity: 0.08;
  left: -3%;
  top: -18%;
}
.commendBanner a::after {
  content: "";
  background: url("https://presale.jhtsoft.com/picms/1ee465d06c2.png");
  display: block;
  position: absolute;
  width: 100%;
  height: 30px;
  bottom: 0;
  opacity: 0.6;
  left: 0;
  right: 0;
  background-size: 100% 100%;
}
.commendBanner a:first-child {
  background: #fa7373;
}
.commendBanner a:nth-child(2) {
  background: #ffa33b;
}
.commendBanner a:nth-child(3) {
  background: #56a9fc;
}
.commendBanner a:nth-child(4) {
  background: #9a8dfc;
}
.commendBanner a {
  width: 49.5%;
  height: 150px;
  color: #fff;
  line-height: 30px;
  padding: 20px;
}
.commendBanner a:hover,.commendBanner a:focus {color:#fff!important; opacity: .8; transition:opacity .4s;}
.commendBanner a span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  text-align: center;
}
.commendBanner a p {
  font-size: 20px;
  font-weight: bold;
}
/* S 仓分享、最新推荐 */
/* S 企业合作概况 */
.pendingTit {
  cursor: auto;
  line-height: 1;
}
.pendingTit b {
  color: #F7615E;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
}
.companyWrap >>> .el-tabs__item {
  font-size: 16px;
  font-weight: bold;
}
.companyWrap >>> .el-tabs__item.is-active {
  color: inherit;
}
.companyWrap >>> .el-tabs__nav {
  padding-bottom: 5px;
}
.companyWrap >>> .el-tabs__active-bar {
  background: var(--main-color);
}
.companyWrap >>> .el-tabs__item:hover {
  color: var(--main-color);
}
.supplyCon .supplyWrap {
  width: calc((100% - 20px) / 2);
  background: #fafafa;
  height: 120px;
  padding: 15px 20px;
}
.companyWrap >>> .el-tabs__header {
  margin-bottom: 0;
}
.companyWrap >>> .el-tabs__nav-wrap::after {
  height: 0;
}
.supplyCon .supplyWrap a {
  cursor: auto;
}
.supplyCon .supplyWrap a h5,
.mediumTit h4 {
  display: inline-block;
  font-size: 14px;
  margin-right: 20px;
  color: #333;
}
.mediumTit:hover {
  color: initial;
}
.supplyCon .supplyWrap a span,
.mediumTit span,
.outNum {
  font-size: 12px;
  color: #999;
}
.supplyCon .supplyWrap a b,
.mediumTit b,
.outNum b {
  color: #F7615E;
  font-size: 14px;
  cursor: pointer;
  font-weight: bold;
}
.supplyCon ul {
  margin-top: 10px;
}
.supplyCon ul li {
  width: 24%;
}
.supplyCon ul li:last-child {
  margin-right: 0;
}
.supplyCon ul li p {
  font-size: 22px;
  font-family: "PingFang SC", "Microsoft YaHei", Arial, Verdana;
  cursor: pointer;
}
.supplyCon ul li span {
  color: #999;
  margin-top: 10px;
}
.dropCon {
  position: absolute;
  right: 20px;
  top: 5px;
}
.dropCon span {
  color: #999;
  font-size: 12px;
  margin-left: 10px;
}
.companyWrap >>> .el-tabs__content {
  position: static;
}
.dropCon .el-select {
  width: 140px;
}
.el-select-dropdown__list li {
  padding: 0 20px;
}
.dropCon >>> .el-input__inner {
  color: #333;
}
.companyWrap {
  padding-top: 5px;
  position: relative;
}
/* E 企业合作概况 */
/* S 商品概况 */
.mediumTit {
  display: block;
  padding-bottom: 5px;
  cursor: auto;
}
.mediumTit h4 {
  font-size: 16px;
  line-height: 40px;
}
.supplyCon .kindWrap {
  margin-top: 0;
}
.kindWrap li:first-child p {
  color: var(--main-color);
}
.kindWrap li:last-child {
  width: 60%;
  background: #fff;
  height: 85px;
  border: 1px solid #ebeef5;
}
.kindWrap li:last-child div {
  display: inline-block;
  width: 49%;
  text-align: center;
}
.kindCon .supplyWrap {
  height: 140px;
}
.kindWrap li:first-child p {
  font-weight: bold;
}
.supplyCon ul li p:hover {
  color: var(--main-color);
}
/* E 商品概况 */
/* S 礼品券卡概况 */
.voucherWrap >>> .el-tabs__nav-wrap::after {
  height: 2px;
  background-color: #f6f8fb;
}
.outNum {
  line-height: 1;
  margin: 20px 0;
}
.allMain {
  width: 100%;
  height: 530px;
}
.el-notification {
  -o-border-radius: 4px !important;
  -ms-border-radius: 4px !important;
  -moz-border-radius: 4px !important;
  -webkit-border-radius: 4px !important;
  border-radius: 4px !important;
}
.none{display: none;}
/* E 礼品券卡概况 */
/* S 自定义首页弹窗 */
.moduleDialog >>> .el-dialog {
  width: 930px;
  height: 745px;
  background: var(--main-color);
  -o-border-radius: 10px;
  -ms-border-radius: 10px;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  top: 50%;
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  margin: 0 auto !important;
  overflow: hidden;
}
.moduleDialog >>> .el-dialog__title,
.moduleDialog >>> .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
  font-size: 18px;
}
.moduleDialog >>> .el-dialog__body {
  padding: 15px 50px;
}
.moduleDialog .el-dialog__body h3 {
  font-size: 20px;
  color: #fff;
}
.moduleDialog >>> .el-dialog__header {
  position: relative;
}
.moduleDialog >>> .el-dialog__header::before {
  content: "";
  position: absolute;
  background: url("https://presale.jhtsoft.com/picms/1ee465d06c2.png") repeat-x;
  background-size: contain;
  transform: rotate(180deg);
  width: 100%;
  height: 63px;
  opacity: 0.6;
  top: 0;
  left: 0;
}
.sortCon {
  background: #fff;
  padding-bottom: 20px;
  color: #666;
}
.sortCon .sortImg {
  -o-border-radius: 4px 4px 0px 0px;
  -ms-border-radius: 4px 4px 0px 0px;
  -moz-border-radius: 4px 4px 0px 0px;
  -webkit-border-radius: 4px 4px 0px 0px;
  border-radius: 4px 4px 0px 0px;
}
.sortCon .sortImg {
  padding: 10px 20px;
}
.sortWrap {
  padding: 20px;
}
.sortCon .sortImg p {
  width: 110px;
  height: 30px;
  text-align: center;
}
.sortCon .sortImg p img {
  max-height: 100%;
  max-width: 100%;
}
.sortItem li {
  width: 550px;
  height: 60px;
  border: 1px solid rgba(235, 238, 245, 1);
  position: relative;
  margin-top: 0;
  margin-bottom: 20px;
}
.sortItem li i {
  position: absolute;
  left: 0;
  width: 6px;
  height: 100%;
  display: block;
  background: var(--main-color);
}
.sortItem .sortHigh {
  background: #e4e7ed;
}
.sortItem .sortHigh i {
  background: #c0c4cc;
}
.sortItem small {
  font-size: 16px;
  color: #333;
}
.sortCon .dialog-footer {
  text-align: center;
}
.sortDouble .sortSingle {
  width: 50%;
  height: 40px;
}
.sortDouble .sortFirst {
  padding-right: 20px;
  border-right: 1px solid #dcdfe6;
}
.sortDouble .sortSingle:last-child {
  padding-left: 20px;
}
.sortCon .dialog-foote {
  text-align: center;
}
.sortCon .el-button--primary {
  background: var(--main-color);
}
.sortCon .dialog-footer .el-button {
  padding: 10px 18px;
  font-size: 16px;
}
.sortCon .el-button--default {
  border: 1px solid #c4c6cc;
  opacity: 0.6;
  color: #666;
}
.sortShape {
  margin-left: 20px;
}
.sortShape li {
  width: 220px;
  height: 100px;
  border: 1px solid #ebeef5;
  margin-bottom: 20px;
  margin-top: 0;
  padding: 20px;
}
.sortShape li:last-child,
.sortItem li:last-child {
  margin-bottom: 0;
}
.sortShape li em,
.sortShape li b {
  display: block;
  width: 80px;
  height: 10px;
  background: #f0f2f5;
}
.sortShape li b {
  width: 120px;
  margin-top: 20px;
}
.el-notification {
  transition: opacity 0.3s, transform 0.3s, left 0.3s, right 0.3s, top 0.4s,
    bottom 0.3s, -webkit-transform 0.3s;
}
.ghost {
  opacity: 0;
}
/* .el-button:hover {
  color: var(--main-color);
  border-color: #c6e2ff;
}
.el-button--primary:hover {
  background: var(--main-color);
  border-color: var(--main-color);
  color: #fff;
} */
/* E 自定义首页弹窗 */
/* S 帮助文档*/
.rightWrap {
  position: relative;
  width: 280px;
  margin-left: 20px;
  transition: top 0.3s;
}
.fixTop {
  top: -70px;
  position: fixed;
  right: 47px;
}
@media (max-width: 1300px) {
  .fixTop {
    top: -22vh;
  }
}
.helpMode {
  width: 100%;
  margin-top: 42px;
}
.helpTop {
  margin-bottom: 10px;
  background: #fff;
  padding: 20px;
}
.helpTop h3,
.serviceWay h3 {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}
.helpTop ul {
  padding-top: 10px;
  height: 151px;
  overflow-y: auto;
}
.helpTab>>>.noMore {
  height: 151px!important;
}
.helpTop ul li {
  overflow: hidden;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 25px;
  color: #666;
  font-size: 12px;
  cursor: pointer;
}
.helpTop ul li:hover,
.helpTop ul li:hover b {
  color: var(--main-color);
}
.helpLink,
.helpTop > a {
  color: var(--main-color);
  line-height: 25px;
  font-size: 12px;
}
.serviceWay {
  background: #fff;
  padding: 20px;
  margin-bottom: 10px;
}
.serviceWay h3 a {
  float: right;
  color: var(--main-color);
  font-weight: normal;
  font-size: 12px;
}
.serviceWay button {
  display: block;
  width: 100%;
  margin: 25px 0;
  border: solid 1px var(--main-color);
  line-height: 40px;
  border-radius: 4px;
  color: var(--main-color);
  background: #fff;
  font-size: 14px;
}
.serviceWay button:before {
  padding-right: 10px;
  font-size: 18px;
}
.serviceWay button:hover {
  background: var(--main-color);
  color: #fff;
  -webkit-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.serviceWay p {
  text-align: center;
  font-size: 12px;
  color: #999;
}
.helpTab >>> .el-tabs__item {
  height: auto;
  line-height: 1;
  padding: 0 15px 10px 15px;
  padding-bottom: 10px;
  font-weight: bold;
}
.helpTab >>> .el-tabs__nav-wrap::after {
  height: 0!important;
}
.helpTop ul li b {
  color: #333;
}
.helpApp div {
  margin: 10px 0;
}
.helpApp div a {
  width: 100px;
  height: 100px;
  text-align: center;
  line-height: 100px;
  margin-right: 10px;
}
.helpApp div a img {
  max-width: 100%;
  max-height: 100%;
}
.helpApp div i {
  color: var(--main-color);
  font-size: 20px;
}
.helpApp div:last-child {
  margin-bottom: 0;
}
.helpApp div:last-child i {
  color: #97c03d;
}
.helpApp div b {
  color: #1a1a1a;
  font-weight: bold;
  margin-left: 10px;
}
.helpApp div em {
  color: #999;
  font-size: 12px;
  margin-top: 5px;
  display: block;
}
.helpApp div p {
  width: calc(100% - 130px);
}
.helpTab ul {
  padding-top: 0;
  height: 125px;
  overflow-y: auto;
}
.helpLink:hover {
  color: var(--main-color);
}
/* .el-button:active {
  color: #3a8ee6;
  border-color: #3a8ee6;
  outline: 0;
}
.el-button--primary.is-active,
.el-button--primary:active {
  background: #3a8ee6;
  border-color: #3a8ee6;
  color: #fff;
} */
/* E 帮助文档*/
/* 立即咨询名片样式 */
.ctatdiv {width: 100%;padding: 30px 0;}
.ctatdiv .ctatbox {text-align: left;}
.ctatdiv .wbcd-tit {position: relative;text-align: left;color: #333;line-height:20px;}
.wbcd-tit span {font-weight: 600;display:inline-block;width:auto;max-width:calc(75% - 19px); padding-left:6px;position: relative;}
.wbcd-tit span::before{
  content: '';
  position: absolute;
  left: 0;
  width: 2px;
  height: 13px;
  bottom: 0;
  margin: auto;
  top: 3px;
  background: var(--main-color);
}
.wbcd-tit em {display:inline-block;width:auto;max-width:calc(25% - 17px);padding-left:5px;}
.ctatbox p strong {font-weight: normal !important;vertical-align: top;font-style: normal;}
.ctatbox {position:relative; height:155px;}
.ctatbox p {margin:20px 0; line-height:25px; text-align: left;}
.ctatbox p:nth-child(3) {width: calc(100% - 80px);}
.ctatbox p i.ico {display:inline-block; width:25px; height:25px; margin-right:10px; vertical-align:top; background:url('https://presale.jhtsoft.com/picms/3c8aa2e6da5fd2.png') no-repeat;}
.ico.ico-tel {background-position:0 0;}
.ico.ico-qq {background-position:0 -44px!important;}
.ico.ico-wx {background-position:0 -88px!important;}
.ctatbox span {position:absolute; right:-10px; bottom:0; width:80px; height:80px; padding:5px;border:solid 1px #eee;}
.ctatbox span img {width:80px; height:80px;}
/* E 帮助文档*/
/*新加内部公告 start*/
.topAncBox {align-items: stretch;}
.topAncBox > dl {flex:1 1 calc(20% - 20px);margin-top:20px;min-width: 200px;}
.ml20 {margin-left:20px;}
.topAncBox .pendingCon {flex:1 1 80%;}
.topAncBox dt {font-size: 18px;color:#333;font-weight:bold;line-height: 1;}
.topAncBox dt a {font-size: 14px; font-weight: normal;}
.topAncBox dd.noticeBoxWrap {box-sizing:border-box; height:calc(100% - 36px); box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.06); background: #fff; margin-top: 18px;padding: 15px 20px;overflow: hidden;}
.noticeBoxWrap p {line-height: 26.5px; cursor: pointer;}
.noticeBoxWrap p span {flex:0 0 60%; max-width: 60%;}
.noticeBoxWrap p:hover {color: var(--main-color);}
.noticeInfoBox {overflow-y: auto!important;cursor: pointer;}
.noticeInfoBox h5 {font-size: 14px; font-weight: bold; line-height:25px;}
.noticeInfoBox article { font-size: 14px; color:#999; line-height:25px;text-indent: 2em;}
.noticeInfoBox article img {max-width:100%;}
/*新加内部公告 end*/
@media only screen and (max-width: 1230px) {
  .topAncBox {flex-wrap:wrap;}
  .topAncBox .pendingCon,.topAncBox > dl {flex:1 1 100%;}
  .topAncBox .ml20 {margin-left:0;}
}

/*待处理事项提示 */
.orangeImpTip {padding-left:25px; font-size: 16px!important; color: #FF7018!important;}
.orangeImpTip .btnLoadNew {padding:0 10px; cursor: pointer; color: #3c9bfa; font-size: 16px; font-weight: bold;}
.orangeImpTip .btnLoadNew i {font-size: 16px;}
</style>



// WEBPACK FOOTER //
// src/views/Index/Index.vue